/* eslint-disable import/no-default-export */
import {CartIconController} from './Controller/CartIconController';
// eslint-disable-next-line import/no-extraneous-dependencies
import {controllerFactory as oldControllerFactory} from '@wix/wixstores-client-storefront-sdk';
import {conditionalController} from './conditionalController';
import {SPECS} from '../../constants';
import {ControllerConstructorType, controllerFactory} from './controllerFactory';
import {ExtendedController} from '@wix/wixstores-client-storefront-sdk/dist/src/viewer-script/controller-factory/BaseController';

export const conditionalCartIconControllerFactory = (controller: ControllerConstructorType<CartIconController>) =>
  conditionalController(
    SPECS.UseNewControllerFactoryInCartIcon,
    controllerFactory(controller),
    oldControllerFactory(controller as unknown as ControllerConstructorType<ExtendedController>, {
      shouldSkipMultilingual: true,
    })
  );

export default conditionalCartIconControllerFactory(CartIconController);
